class StringHelper {
    /**
     * Return a filtered and unique string array
     * @param {string[]} array
     * @returns {string[]}
     */
    public static makeUniqueArray(array: string[]): string[] {
        return array.filter(p => !IsNullOrWhiteSpace(p)).distinct();
    }

    /**
     * Return a lowercased and merged string
     * @param {string[]} array
     * @returns {string[]}
     */
    public static makeLowercasedMergedString(array: string[]): string {
        return array.map(p => IsNullOrUndefined(p) ? p : p.toLowerCase()).join(" ");
    }

    /**
     * Return a merged string after filtering null, undefined, and empty string
     * @param {string[]} array
     * @returns {string[]}
     */
    public static makeMergedString(array: string[]): string {
        return array.filter(p => !IsNullOrWhiteSpace(p)).join(" ");
    }
}

export { StringHelper };
